import { useState, useEffect } from "react";

const Maintenance = () => {
  const [fillLevel, setFillLevel] = useState(0); // 0 à 100
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    // Remplissage progressif du logo
    const fillTimer = setInterval(() => {
      setFillLevel(prev => {
        if (prev >= 100) {
          clearInterval(fillTimer);
          // Une fois plein, afficher le message
          setTimeout(() => {
            setShowMessage(true);
          }, 500);
          return 100;
        }
        return prev + 1; // Augmente de 1% toutes les 50ms
      });
    }, 50);

    return () => {
      clearInterval(fillTimer);
    };
  }, []);

  return (
    <div className="maintenance-page">
      {/* Header */}
      <header className="bg-slate-900 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex justify-between items-center">
          <a 
            href="https://slaunay.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center cursor-pointer hover:opacity-80 transition-opacity duration-300"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_ticketing/artifacts/wjnjnbgd_Slaunay%20-%20contour.png" 
              alt="SLAUNAY" 
              className="h-6 sm:h-7 md:h-8 brightness-0 invert"
            />
          </a>
          
          {/* Boutons navigation */}
          <div className="flex items-center gap-2 sm:gap-3">
            <a
              href="https://support.slaunay.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="header-btn header-btn-support"
            >
              <span className="hidden md:inline">Support / Ticket</span>
              <span className="md:hidden">Support</span>
            </a>
            
            <a
              href="https://sos.slaunay.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="header-btn header-btn-sos"
            >
              <span className="hidden lg:inline">SOS - Demande d'assistance à distance</span>
              <span className="lg:hidden">SOS</span>
            </a>
            
            <a
              href="mailto:contact@slaunay.com"
              className="header-btn header-btn-contact"
            >
              Contact
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="maintenance-content">
        {/* Animation de vagues en arrière-plan */}
        <div className="wave-background">
          <svg width="100%" height="100%" viewBox="0 0 1500 1000" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
              <path className="dash dash_0" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
              
              <path className="dash dash_1" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
              
              <path className="dash dash_2" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
              
              <path className="dash dash_3" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
              
              <path className="dash dash_4" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
              
              <path className="dash dash_5" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
              
              <path className="dash dash_6" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
              
              <path className="dash dash_7" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
              
              <path className="dash dash_8" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
              
              <path className="dash dash_9" d="M16,16 C76.235,16 77.932,77 138.167,77 C198.402,77 198.402,16 260.333,16 C320.568,16 322.265,77 382.5,77 C442.735,77 442.735,16 504.667,16 C564.902,16 566.598,77 626.833,77 C687.068,77 687.068,16 749,16 C809.235,16 810.932,77 871.167,77 C931.402,77 931.402,16 993.333,16 C1053.568,16 1055.265,77 1115.5,77 C1175.735,77 1175.735,16 1237.667,16 C1297.902,16 1299.598,77 1359.833,77 C1420.068,77 1420.068,16 1482,16" strokeWidth="32" />
            </g>
          </svg>
        </div>
        
        <div className="maintenance-animation-container">
          {/* Logo qui se remplit */}
          <div className="logo-fill-wrapper">
            {/* Logo contour (toujours visible) */}
            <div className="logo-base">
              <img 
                src="https://customer-assets.emergentagent.com/job_ticketing/artifacts/wjnjnbgd_Slaunay%20-%20contour.png" 
                alt="SLAUNAY" 
                className="logo-outline-img"
              />
            </div>
            
            {/* Logo rempli (niveau monte progressivement) */}
            <div className="logo-liquid-container">
              <div 
                className="logo-liquid-fill" 
                style={{ 
                  clipPath: `inset(${100 - fillLevel}% 0 0 0)`,
                  transition: 'clip-path 0.05s ease-out'
                }}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_ticketing/artifacts/wjnjnbgd_Slaunay%20-%20contour.png" 
                  alt="SLAUNAY" 
                  className="logo-filled-img"
                />
              </div>
            </div>
          </div>

          {/* Message qui apparaît une fois le logo chargé */}
          {showMessage && (
            <div className="message-wrapper fade-in">
              <div className="message-text">
                Site en cours de développement
              </div>
            </div>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 border-t border-slate-800 py-3 sm:py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex justify-center items-center text-xs sm:text-sm text-slate-500">
          <p>
            © 2025{" "}
            <a 
              href="https://slaunay.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors duration-300 underline"
            >
              SLAUNAY
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Maintenance;
